module.exports = __webpack_public_path__ + "img/mail_white.78904c43.svg";